import { docReady } from "../utilities";
import Favourites from '../libraries/Favourites';
import '../styles/templates/search.scss';

docReady(function() {
    Favourites.init();
    Favourites.initButtons();
});
